const getBusinessLinePath = () => {
  const pathSegments = window.location.pathname.split("/").filter(segment => segment !== "");
  return pathSegments.length > 0 ? pathSegments[0] : null;
};

const getOrderToken = () => {
  const $element = document.getElementById("js-checkout_v2-thank-you");
  return $element ? $element.dataset.orderToken : "";
};

export { getBusinessLinePath, getOrderToken };
